module.exports = __webpack_public_path__ + "static/media/Residential_Study_Courses_mr.f9619b10.jpg";